import {
  useMediaQuery,
  Grid,
  ListItem,
  ListItemAvatar,
  Typography,
  Avatar,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

const useStyles = makeStyles(() => ({
  checkBox: {
    background: 'transparent',
    borderRadius: 0,
  },
  listItemAvatar: {
    alignSelf: 'flex-start',
  },
}));

const Sales = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item container justifyContent="center" xs={12} md={6} data-aos="fade-up">
          <Image src="/images/illustrations/platform/feature-2.svg" width="100%" />
        </Grid>
        <Grid item xs={12} md={6} data-aos="fade-up">
          <Grid container alignItems="flex-start" justifyContent="center" direction="column">
            <SectionHeader
              label="Diferentes tipos de pedidos para venda"
              title="Comercialize de forma diferente, para cada necessidade"
              subtitle="Tenha flexibilidade para definir o melhor modelo de cobrança, seja como pedido único, contrato ou mensalidade."
              align="left"
              disableGutter
            />
            <Grid container spacing={2}>
              {data.map((item, index) => (
                <Grid item xs={12} sm={6} key={index.toString()} data-aos="fade-up">
                  <ListItem disableGutters>
                    <ListItemAvatar className={classes.listItemAvatar}>
                      <Avatar
                        src="https://assets.maccarianagency.com/the-front/illustrations/check-icon-yellow.svg"
                        className={classes.checkBox}
                      />
                    </ListItemAvatar>
                    <Typography variant="subtitle1" color="textPrimary">
                      {item}
                    </Typography>
                  </ListItem>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

Sales.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Sales;
